import { Edit as EditIcon } from '@mui/icons-material';
import { type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'src/components/menu/Menu';
import { PATHS } from 'src/constants/paths';

import { ProductMenuProps } from './ProductMenu.interface';

export const ProductMenu = (props: ProductMenuProps) => {
  const navigate = useNavigate();
  const onEditClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    navigate(PATHS.PRODUCT_EDIT(props.card.product_code));
    props.onClose();
  };

  const items = [
    {
      label: 'Edit',
      onClick: onEditClick,
      leftIcon: <EditIcon />,
      disabled: false,
    },
  ];

  return (
    <>
      <Menu anchorEl={props.anchorEl} items={items} onClose={props.onClose} />
    </>
  );
};
